/* Generated by ./script/iconify.js */
/* eslint-disable */
import React, { PropTypes } from 'react'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconCheck = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--check',
    className,
  )

  return (
    <IconBase className={classes}  viewBox="0 0 18 14"{...rest}><g fill="none" fillRule="evenodd"><path className="path1" d="M-3-5h24v24H-3z"/><path className="path2" fill="#86BD24" fillRule="nonzero" d="M6 11.17L1.83 7 .41 8.41 6 14 18 2 16.59.59z"/></g></IconBase>
  )
}

IconCheck.propTypes = {
  className: PropTypes.string,
}

export default IconCheck
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconCheck.js